@let hasAbsenceReadPermission =
  can(RoleAction.Read, RolePermissionSubject.Absence);

<nz-collapse [nzBordered]="false" nzGhost class="mt-2">
  <nz-collapse-panel
    #absencesPanel
    class="collapse-panel"
    [nzHeader]="absencesSectionHeader"
    [nzActive]="true"
    [nzShowArrow]="false"
    [nzExtra]="absencesCollapseIcon"
  >
    <div>
      <span class="mb-0 filter-label">
        {{
          'agreement.rules.TimeFrameMinimumRate.abscence_categories.label'
            | translate
        }}
      </span>
      @if (hasAbsenceReadPermission) {
        <wilson-absences-filter
          class="mb-2"
          [placeholder]="
            'agreement.rules.TimeFrameMinimumRate.abscence_categories.label'
              | translate
          "
          (modelChange)="absencesChanged($event)"
        ></wilson-absences-filter>
      } @else {
        <nz-select
          class="mb-2"
          nzMode="multiple"
          [nzPlaceHolder]="
            'agreement.rules.TimeFrameMinimumRate.abscence_categories.label'
              | translate
          "
          nzAllowClear
          [nzShowArrow]="true"
          [nzDisabled]="true"
          nz-tooltip
          [nzTooltipTitle]="'general.forbidden_action' | translate"
          data-test-id="wilson-timeline-filter:absences-select"
        ></nz-select>
      }
    </div>
  </nz-collapse-panel>
  <ng-template #absencesSectionHeader>
    <span class="fw-normal">
      {{ 'sidenav.absences' | translate }}
    </span>
  </ng-template>
  <ng-template #absencesCollapseIcon>
    <fa-icon
      [icon]="absencesPanel.nzActive ? faChevronUp : faChevronDown"
    ></fa-icon>
  </ng-template>
</nz-collapse>
